import { captureEvent } from './posthog';

export function initWebVitals() {
	import('web-vitals').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
		const send = (metric: {
			name: string;
			value: number;
			rating: string;
			delta: number;
			id: string;
		}) => {
			captureEvent('web_vital', {
				name: metric.name,
				value: metric.value,
				rating: metric.rating,
				delta: metric.delta,
				id: metric.id
			});
		};

		onCLS(send);
		onINP(send);
		onLCP(send);
		onFCP(send);
		onTTFB(send);
	});
}
